// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-up.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-up',
  version: 'solid',
  paths: [
    {
      d: 'M11.364 7.764a.9.9 0 0 1 1.272 0l5.1 5.1a.9.9 0 1 1-1.272 1.272L12 9.672l-4.464 4.464a.9.9 0 0 1-1.272-1.272l5.1-5.1',
      fillRule: 'evenodd',
    },
  ],
}
